import Image from 'next/image';
import React from 'react';

import type { LoanSchemeType } from '@/api/avail-loan';

import CloseIcon from '../../../assets/images/icons/close-icon.svg';
import GlNewNote from '../gold-loan/GlNewNote';

type LoanSchemesTypes = {
  loanScheme: LoanSchemeType;
};

export const LoanSchemes = ({ loanScheme }: LoanSchemesTypes) => {
  const MonthlyBaseRate = loanScheme.baseRate / 12;

  return (
    <div>
      <div
        className="modal loanDetails__modal fade"
        id="loanDetail"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="loanDetailLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="header">
              <div className="modal__title">
                <p className="text--semi text--black">Interest rate details</p>
                <a href="#" data-dismiss="modal">
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={CloseIcon}
                    alt="close icon"
                    height={100}
                    width={100}
                  />
                </a>
              </div>
              <div className="modal__detail">
                <p className="text--bold text--black title">
                  Get the lowest interest by paying on time
                </p>
                <p className="text--regular text--gray desc">
                  Your interest rate will get updated to the next slab if you
                  miss paying interest on time
                </p>
                <p className="text--regular text--gray desc">
                  But don’t worry, once you pay all the interest accrued till
                  that time, the interest rate will return back to it’s default
                  slab
                </p>
              </div>
            </div>
            <p className="interest text--gray text--regular">
              Base Interest Rate{' '}
              <span className="text--bold text--black">
                {MonthlyBaseRate.toFixed(2)}% p.m. |{' '}
                {loanScheme.baseRate.toFixed(2)}% p.a.
              </span>
            </p>
            <div style={{ marginTop: '-24px', marginBottom: '10px' }}>
              <GlNewNote />
            </div>

            <div className="interestDetail">
              <p className="text--semi text--black title">
                Interest Rate Slabs*
              </p>
              <div className="interestTable table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>If interest defaulted by (in days)</th>
                      <th>Interest rate applicable (per month)</th>
                      <th>Interest rate applicable (per annum)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loanScheme.ranges.map((range) => {
                      const MonthlyInterestRate = range.rateOfInterest / 12;
                      return (
                        <tr key={range.id}>
                          <td>
                            {range.startDayCount} - {range.endDayCount}
                          </td>
                          <td>{MonthlyInterestRate.toFixed(2)}%</td>
                          <td>{range.rateOfInterest.toFixed(2)}%</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
